import { render, staticRenderFns } from "./extraHeadersComponent.vue?vue&type=template&id=f5052244&scoped=true"
import script from "./extraHeadersComponent.vue?vue&type=script&lang=js"
export * from "./extraHeadersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5052244",
  null
  
)

export default component.exports